import '../styles.scss'
import React from 'react'

import { Selector } from 'components/SmartChatView/Fields'

const SelectorViewUI = ({ renderType, label, placeholder, options, value, onChangeInner, link, tooltip, loading, error, previewIntegrity }) => (
  <div className='action-view'>
    {renderType === 'action' && (
      <Selector
        isRequired
        label={renderType === 'action' ? label : null}
        placeholder={placeholder}
        options={options || []}
        value={value}
        onChange={onChangeInner}
        link={link}
        tooltip={tooltip}
        loading={loading}
        error={error}
      />
    )}
    {renderType === 'preview' && (
      <div className='action-view__selector-preview'>
        <Selector
          label={renderType === 'action' ? label : null}
          placeholder={placeholder}
          options={options || []}
          value={value}
          onChange={onChangeInner}
          link={link}
          tooltip={tooltip}
          loading={loading}
          error={previewIntegrity}
        />
      </div>
    )}
  </div>
)

export default SelectorViewUI
